interface Feature {
  icon: string;
  title: string;
  description: string;
}

const features: Feature[] = [
  {
    icon: 'ri-stack-fill',
    title: '圧倒的な在庫量',
    description: '常時数百本以上の中古タイヤをストック。軽自動車から大型トラックまで、お探しのサイズが必ず見つかります。',
  },
  {
    icon: 'ri-price-tag-3-fill',
    title: '適正価格',
    description: '中間業者なし。仕入れから販売まで自社で一貫。不要なマージンをカットした圧倒的なコストパフォーマンスを実現。',
  },
  {
    icon: 'ri-time-fill',
    title: '年中無休対応',
    description: '9:00〜18:00（不定期休みのみ）、基本年中無休で営業。急なタイヤトラブルにも迅速に対応いたします。',
  },
];

export default function FeaturesSection() {
  return (
    <section
      id="features"
      className="py-20 md:py-28"
      style={{ backgroundColor: '#1a1a1a' }}
      aria-label="特徴・強み"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <p
            className="text-xs font-bold tracking-widest uppercase mb-3"
            style={{ color: '#f5a623', fontFamily: '"Oswald", sans-serif', letterSpacing: '4px' }}
          >
            Our Strengths
          </p>
          <h2
            className="text-3xl md:text-4xl font-black text-white"
            style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
          >
            baba Kabaが選ばれる<span style={{ color: '#f5a623' }}>3つの理由</span>
          </h2>
          <div
            className="w-16 h-1 mx-auto mt-5"
            style={{ backgroundColor: '#f5a623' }}
          />
        </div>

        {/* Feature cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <FeatureCard key={index} feature={feature} />
          ))}
        </div>
      </div>
    </section>
  );
}

function FeatureCard({ feature }: { feature: Feature }) {
  return (
    <article
      className="group relative p-8 md:p-10 transition-all duration-300 cursor-default"
      style={{
        border: '1px solid rgba(255,255,255,0.08)',
        backgroundColor: 'rgba(255,255,255,0.02)',
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLElement).style.borderColor = 'rgba(245,166,35,0.4)';
        (e.currentTarget as HTMLElement).style.backgroundColor = 'rgba(245,166,35,0.05)';
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLElement).style.borderColor = 'rgba(255,255,255,0.08)';
        (e.currentTarget as HTMLElement).style.backgroundColor = 'rgba(255,255,255,0.02)';
      }}
    >
      {/* Top amber accent bar */}
      <div
        className="absolute top-0 left-0 right-0 h-1 transition-opacity duration-300 opacity-0 group-hover:opacity-100"
        style={{ backgroundColor: '#f5a623' }}
      />

      {/* Icon */}
      <div
        className="w-16 h-16 flex items-center justify-center rounded mb-6"
        style={{ backgroundColor: 'rgba(245,166,35,0.12)', border: '1px solid rgba(245,166,35,0.3)' }}
      >
        <i className={`${feature.icon} text-2xl`} style={{ color: '#f5a623' }}></i>
      </div>

      {/* Title */}
      <h3
        className="text-xl font-black text-white mb-4"
        style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
      >
        {feature.title}
      </h3>

      {/* Description */}
      <p
        className="text-sm leading-relaxed"
        style={{ color: 'rgba(255,255,255,0.7)', fontFamily: '"Noto Sans JP", sans-serif', lineHeight: '1.9' }}
      >
        {feature.description}
      </p>
    </article>
  );
}